@if (visibleSignals.length > 0) {
  <ul class="trust-signals-preview">
    @for (signal of visibleSignals; track signal.id) {
      <li class="trust-signals-preview__row">
        @if (signal.renderedIconUrl) {
          <img class="trust-signals-preview__icon" [src]="signal.renderedIconUrl" alt="" />
        }
        <span class="trust-signals-preview__text">{{ signal.text }}</span>
      </li>
    }
  </ul>
}
